import React, { useEffect, useRef } from "react";
import ProjectCard from "./ProjectCard";
import "../../../styles/components/AllProjects/Projects.css";
import { useLanguage } from "../../../hooks/LanguageContext";

const Projects = () => {
  const { isEnglish } = useLanguage();

  const projects = [
    {
      title: "FreePDF Studio",
      image: "pdf_editor_icon.jpg",
      technologies: ["React", "PDF.js", "pdf-lib"],
      description: {
        en: "A fully free, premium-grade PDF editor that runs entirely in your browser. Upload any PDF and annotate with highlights, drawings, shapes, text, sticky notes, stamps and images. Add handwritten signatures, redact sensitive content, rotate or delete pages, merge multiple PDFs, extract page ranges, apply watermarks and page numbers — then download the edited file. No accounts, no watermarks on your work, nothing uploaded to a server.",
        esp: "Un editor de PDF premium y totalmente gratis que funciona entero en tu navegador. Sube cualquier PDF y anótalo con resaltados, dibujos, formas, texto, notas adhesivas, sellos e imágenes. Añade firmas manuscritas, redacta contenido sensible, rota o elimina páginas, fusiona varios PDFs, extrae rangos de páginas, aplica marcas de agua y numeración y descarga el archivo editado. Sin cuentas, sin marcas de agua en tu trabajo y sin subir nada a un servidor.",
      },
      link: "/pdf-editor",
    },
    {
      title: "AngelesBurguer",
      image: "angelesburguer.png",
      technologies: ["React", "Node.js", "Firebase"],
      description: {
        en: "AngelesBurguer is a mobile application designed for a restaurant that facilitates order management. Users can view products, manage their cart, and place orders using various payment methods. The app includes user authentication and personal data management, providing a smooth experience for both customers and staff. Orders are stored in Firebase, with details such as total cost, payment method, and customer information securely stored. Additionally, it features an admin mode, which allows managing all data from within the application itself.",
        esp: "AngelesBurguer es una aplicación móvil diseñada para un restaurante que facilita la gestión de pedidos. Los usuarios pueden ver los productos, gestionar su carrito y realizar pedidos utilizando varios métodos de pago. La app incluye autenticación de usuarios y gestión de datos personales, brindando una experiencia fluida tanto para clientes como para el personal. Los pedidos se almacenan en Firebase, con detalles como el costo total, método de pago e información del cliente de manera segura. Además, cuenta con un modo administrador, que permite gestionar todos los datos desde la propia aplicación.",
      },
      link: "https://play.google.com/store/apps/details?id=com.appAngelesBurguer&hl=es",
      projectImages: [
        "AB1.PNG",
        "AB2.PNG",
        "AB3.PNG",
        "AB4.PNG",
        "AB5.PNG",
        "AB6.PNG",
        "AB7.PNG",
        "AB8.PNG",
        "AB9.PNG",
        "AB10.PNG",
        "AB11.PNG",
        "AB12.PNG",
        "AB13.PNG",
        "AB14.PNG",
      ],
    },
    {
      title: "Finance App",
      image: "icon_finances_app.png",
      technologies: ["React Native (Expo)", "TypeScript", "Firebase"],
      description: {
        en: "A cross-platform financial suite built with a Mobile-First architecture using React Native & Expo. Features real-time synchronization for individual and joint accounts (Group Economy) powered by Firebase Firestore. Includes smart multi-currency support (EUR, USD, COP), adaptive Dark Mode, and advanced transaction filtering. Deployed seamlessly as a micro-frontend web app via Expo Router.",
        esp: "App financiera multiplataforma construida con arquitectura Mobile-First usando React Native y Expo. Ofrece sincronización en tiempo real para cuentas individuales y conjuntas (Economía Grupal) mediante Firebase Firestore. Incluye soporte inteligente multi-divisa (EUR, USD, COP), Modo Oscuro adaptativo y filtrado avanzado de transacciones. Desplegada como una web-app integrada (micro-frontend) mediante Expo Router.",
      },
      link: "/finances",
    },
  ];

  const sectionRefs = useRef([]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible");
          }
        });
      },
      { threshold: 0.1 }
    );

    const currentRefs = sectionRefs.current.filter(Boolean);
    currentRefs.forEach((ref) => observer.observe(ref));

    return () => {
      currentRefs.forEach((ref) => {
        if (ref) observer.unobserve(ref);
      });
    };
  }, []);

  return (
    <section className="projects-container page-atmosphere">
      <header className="projects-header">
        <h2 className="projects-heading">
          {isEnglish ? "Selected work" : "Proyectos destacados"}
        </h2>
        <p className="projects-subtitle">
          {isEnglish
            ? "Products I've built end to end — from idea to launch."
            : "Productos que he construido de punta a punta — de la idea al lanzamiento."}
        </p>
      </header>
      <div className="projects-grid">
        {projects.map((project, index) => (
          <div
            key={project.title}
            className="project-section"
            ref={(el) => {
              sectionRefs.current[index] = el;
            }}
          >
            <ProjectCard
              title={project.title}
              description={project.description}
              technologies={project.technologies}
              image={project.image}
              link={project.link}
              projectImages={project.projectImages}
            />
          </div>
        ))}
      </div>
    </section>
  );
};

export default Projects;
